






import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
//引入基本模板
let echarts = require("echarts");

// 引入折线图等组件
require("echarts/lib/chart/line");
// 引入柱状图组件
//require('echarts/lib/chart/bar')
//require('echarts/lib/chart/radar')

// 引入提示框和title组件，图例
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
//require('echarts/lib/component/legend')
//require('echarts/lib/component/legendScroll')//图例翻译滚动
@Component
export default class HomeDowns extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({type:String}) legenddata:string;
  @Prop({type:String}) xAxisdata:string;
  @Prop({type:String}) seriesdata:string;
  
  
  created() {}
 
  // 指定图表的配置项和数据
  option = {
    title: {
        text: '各库房本月烟虫趋势'
    },
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        data: []
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
    },
    yAxis: {
        type: 'value'
    },
    series: []
};
  drawLine() {
    //图表
    // 基于准备好的dom，初始化echarts实例
    var myChart = echarts.init(document.getElementById("myChart"));

    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(this.option);
  }
   mounted() {
     if(this.seriesdata!=""){
       //console.log(JSON.parse(this.seriesdata));
       this.option.legend.data=JSON.parse(this.legenddata);
       this.option.xAxis.data=JSON.parse(this.xAxisdata);
       this.option.series=JSON.parse(this.seriesdata);
   }
     this.drawLine();
  }
}
